import { isDematUser } from '../../utils/AuthUtil'
import KycUserHomePage from '../Home/KycUserHomePage'
import NonKycUserHomePage from '../Home/NonKycUserHomePage'

const Homepage = () => {
  return (
    <>
      {/* <p className='text-sm text-black-400 text-center mt-2'> Pull to refresh</p> */}
      {isDematUser() ? <KycUserHomePage /> : <NonKycUserHomePage />}
    </>
  )
}

export default Homepage
